import { findAppByKey, findAppForPath, type InstallableApp } from "~/pwa/installableApps";

interface StandaloneResolution {
	app: InstallableApp | null;
	adoptedFromPath: boolean;
}

const resolveStandaloneApp = (
	isStandalone: boolean,
	storedKey: string | null,
	pathname: string
): StandaloneResolution => {
	if (!isStandalone) return { adoptedFromPath: false, app: null };

	const storedApp = findAppByKey(storedKey);
	if (storedApp) return { adoptedFromPath: false, app: storedApp };

	const pathApp = findAppForPath(pathname);
	if (!pathApp) return { adoptedFromPath: false, app: null };

	return { adoptedFromPath: storedKey != null, app: pathApp };
};

export type { StandaloneResolution };
export default resolveStandaloneApp;
